import { render, staticRenderFns } from "./cModalAddMarcaAct.vue?vue&type=template&id=212408fe"
import script from "./cModalAddMarcaAct.vue?vue&type=script&lang=js"
export * from "./cModalAddMarcaAct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports